// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"f0db81cc","124":"aab1c16a","129":"959cb741","179":"b33e09bf","185":"da6774a8","318":"e04d0f21","380":"90cef791","697":"b9314ba4","761":"87ecf4a9","928":"1e8f2754","990":"e361856d"}[chunkId] + ".chunk.js";
};